export const hardOrSoftWoodArray = ['New - Hardwood', 'New - Softwood'];

export const woodConditions = ["Recycled", "New", "Combo"];

export const plasticConditions = ["Recycled", "New"];

export const materialArr = [
  { id: "0", label: "Wood", value: "WOOD" },
  { id: "1", label: "Plastic", value: "PLASTIC" },
  { id: "2", label: "Other", value: "OTHER" }
];

export const palletList = [
  { label: "Block", value: "block", id: 0 },
  { label: "Stringer", value: "stringer", id: 1 },
  { label: "Euro Pallet", value: "euroPallet", id: 2 },
  { label: "Crate", value: "crate", id: 3 },
  { label: "Tray", value: "tray", id: 4 },
  { label: "Other", value: "other", id: 5 }
];

export const comboPalletList = [
  { label: "Stringer", value: "stringer", id: 1 },
  { label: "Crate", value: "crate", id: 2 },
  { label: "Custom", value: "custom", id: 3 }
];

export const materialOptions = [
  { label: "Wood", value: "WOOD" },
  { label: "Plastic", value: "PLASTIC" },
  { label: "Other", value: "OTHER" }
];

export const woodConditionOptions = [
  { label: "Recycled", value: "RECYCLED" },
  { label: "New", value: "NEW" },
  { label: "Combo", value: "COMBO" }
];

export const plasticConditionOptions = [
  { label: "Recycled", value: "RECYCLED" },
  { label: "New", value: "NEW" }
];

export const equipmentList = ['Flatbed', 'Enclosed Trailer', 'Straight Truck'];

export const corePalletList = [
  { label: "Block", value: "block", id: 0 },
  { label: "Stringer", value: "stringer", id: 1 }
];
